import { render, staticRenderFns } from "./examSingle.vue?vue&type=template&id=2c933d46&scoped=true&"
import script from "./examSingle.vue?vue&type=script&lang=js&"
export * from "./examSingle.vue?vue&type=script&lang=js&"
import style0 from "./examSingle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./examSingle.vue?vue&type=style&index=1&id=2c933d46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c933d46",
  null
  
)

export default component.exports